import React, { useEffect, useState } from "react";
import {
  Collapse,
  Descriptions,
  Form,
  Input,
  Button,
  Row,
  Col,
  message,
  Select,
  InputNumber,
  Checkbox,
  Card,
} from "antd";
import utils from "utils";
import api from "utils/api";
import Loader from "Components/Loader";
import icons from "Common/Icons";
import { EditOutlined } from "@ant-design/icons";
import { PanelEdit } from "./VitalFormEdit";
const { Panel } = Collapse;

export const YourComponent = ({ data }) => {
  const [editMode, setEditMode] = useState(null);
  
  const renderNestedItems = (items) => {
    return items?.map((item, index) => (
      <>
        {item.value && (
          <Descriptions.Item
            label={<b style={{ alignSelf: "center" }}>{item.label}</b>}
            key={index}
          >
            <span style={{ alignSelf: "center" }}>
              {item.value} {item.unit}
            </span>
          </Descriptions.Item>
        )}
      </>
    ));
  };

  
  return (
    <>
      {data.length > 0 ? (
        <div>
          {data?.map((entry, index) => (
            <PanelEdit entry={entry} index={index} key={index} editMode={editMode} setEditMode={setEditMode}/>
          ))}
        </div>
      ) : (
        <div className="emptyHistoryDiv">
          <div className="emptyHistoryTitle">
            <img
              src={icons.empty_folder_icon}
              style={{ width: "24px", height: "24px" }}
              alt=" "
            />
            No data to show
          </div>
          <div className="emptyHistorySubTitle">
            Submit Vital Form to show History
          </div>
        </div>
      )}
    </>
  );
};

export default YourComponent;
